module.exports = __webpack_public_path__ + "static/media/football-carousel-2-1366x1024.ea655151.jpg";